import React from 'react';
const links = ['Términos y condiciones', 'Política de privacidad', 'Política de reembolso', 'Contacto'];
export function Footer() {
  return <footer className="w-full bg-ink px-5 pb-16 pt-16" data-id="element-94" data-mp="3ggu1qsai619z">
      <div className="mx-auto max-w-5xl text-center" data-id="element-95" data-mp="32oe11y52qfc8">
        <p className="font-display text-3xl leading-none text-white" data-id="element-96" data-mp="32lrkxa44arie">
          INGLES LISTO<span className="text-brand" data-id="element-97" data-mp="36pz9966ny5g3">™</span>
        </p>
        <p className="mt-4 font-display text-lg tracking-[0.06em] text-volt" data-id="element-98" data-mp="3ueiltxwqx4dz">
          Planifica menos. Enseña con autoridad.
        </p>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-white/50" data-id="element-99" data-mp="387e5ix8d5do">
          Material de Inglés listo para ejecutar, organizado por niveles de
          competencia progresiva del A1 al B1+.
        </p>
        <nav aria-label="Pie de página" data-id="element-100" data-mp="3qfjhofiu9bnl">
          <ul className="mt-9 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-sm font-semibold text-white/60" data-id="element-101" data-mp="29ynk7hc24zcf">
            {links.map(link => <li key={link} data-id="element-102" data-mp="2ezl4q0kji5h3">
                <a href="#offer" className="transition-colors duration-150 ease-out hover:text-volt" data-id="element-103" data-mp="3l9k1v1qqp380">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-10 max-w-2xl border-t border-white/10 pt-8 text-xs leading-relaxed text-white/40" data-id="element-104" data-mp="3v7q5bns72hez">
          © 2026 Ingles Listo™. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}